import LLCMyServiceContent from "./LLCMyServiceContent";

export default function LLCMyService() {
  return <LLCMyServiceContent />;
}
